function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import Spinner from '../Spinner';

const Button = ({
  className,
  title,
  onClick,
  type = 'primary',
  disabled,
  loading,
  ...props
}) => /*#__PURE__*/React.createElement("button", _extends({
  disabled: disabled || loading,
  onClick: onClick,
  className: classNames(styles.container, type === 'secondary' && styles.secondary, className)
}, props), !loading ? /*#__PURE__*/React.createElement("span", null, title) : /*#__PURE__*/React.createElement(Spinner, {
  secondary: true,
  size: 40
}));

export default Button;